﻿import React, { Fragment } from 'react';

import { TwoColumnWrapper } from '../../../../../Resources/Scripts/_Shared/elements/ColumnWrapper'
import { InputWithLabel } from '../../../../../Resources/Scripts/_Shared/elements/InputWithLabel'

const CreateAccountGuest = (props) => {
	const formLang = props.waitingListFlowContext.localization.createAccount;
	const formData = props.formData;
	const handleKeyDown = props.handleKeyDown;

	return (
		<Fragment>
			<h3>{formLang.subheadings.guest}</h3>
			<TwoColumnWrapper>
				<InputWithLabel inputType="text" text={formLang.firstName} defaultText={formData.firstName} value={formData.firstName} setValue={formData.setFirstName} keyDown={handleKeyDown} />
				<InputWithLabel inputType="text" text={formLang.lastName} defaultText={formData.lastName} value={formData.lastName} setValue={formData.setLastName} keyDown={handleKeyDown} />
				<InputWithLabel inputType="email" text={formLang.email} defaultText={formData.email} value={formData.email} setValue={formData.setEmail} keyDown={handleKeyDown} />
			</TwoColumnWrapper>
		</Fragment>
	)
}

export default CreateAccountGuest;
